import React from 'react';
import { styled } from '@linaria/react';

import DefaultButton from '@/components/DefaultButton';

const random = (min, max) =>
  Math.floor(Math.random() * (max - min)) + min;

// Default color is a bright yellow
const DEFAULT_COLOR = 'hsl(50deg, 100%, 50%)';

const generateSparkle = (color = DEFAULT_COLOR) => {
  return {
    id: String(random(10000, 99999)),
    createdAt: Date.now(),
    // Bright yellow color:
    color,
    size: random(10, 20),
    // Pick a random spot in the available space
    style: {
      top: random(0, 100) + '%',
      left: random(0, 100) + '%',
    },
  };
};

function SparkleInstance({ color, size, style }) {
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 160 160"
      fill="none"
      style={style}
    >
      <path
        d="M80 0C80 0 84.2846 41.2925 101.496 58.504C118.707 75.7154 160 80 160 80C160 80 118.707 84.2846 101.496 101.496C84.2846 118.707 80 160 80 160C80 160 75.7154 118.707 58.504 101.496C41.2925 84.2846 0 80 0 80C0 80 41.2925 75.7154 58.504 58.504C75.7154 41.2925 80 0 80 0Z"
        fill={color}
      />
    </Svg>
  );
}

function InitialSparkleDemo({ children }) {
  const [sparkle, setSparkle] = React.useState(generateSparkle);

  return (
    <Wrapper>
      <SparkleInstance
        color={sparkle.color}
        size={sparkle.size}
        style={sparkle.style}
      />
      <DefaultButton onClick={() => setSparkle(generateSparkle())}>
        Regenerate
      </DefaultButton>
    </Wrapper>
  );
}

const Svg = styled.svg`
  position: absolute;
  pointer-events: none;
`;

const Wrapper = styled.div`
  position: relative;
`;

export default InitialSparkleDemo;
